import type { DomainRecord } from '@/entities/domain';
import request from '@/shared/api/request';

export const getDomainRecords = (name: string): Promise<{ records: DomainRecord[] }> =>
  request({
    url: `/domains/${name}/records/`,
  });
